import { type ButtonProps, type ChakraProps } from "@chakra-ui/react"

export const buttonStyles: ButtonProps = {
  variant: "link",
  color: "white",
  alignSelf: "flex-start",
  height: "24px",
  my: "2"
}
export const errorMessageStyles: ChakraProps = {
  m: "4",
  bg: "orange.500",
  color: "white",
  w: "100%",
  fontSize: "16",
  p: "4",
  fontWeight: "bold",
  textAlign: "center"
}
